// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1BtyU","row":"ProcedureTreatmentSummary_row__3qGXj"};